import CLabel from "./label";
export default CLabel;
